module.exports = __webpack_public_path__ + "img/welcome-1.9ecccf35.png";